module.exports = __webpack_public_path__ + "475f30565ccf86541669371a629cbba4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-crazy-s.png
// module id = 2826
// module chunks = 0